<template lang="pug">
div.container
  p.title(v-if="endOfSale") 選択した商品の販売は、現在終了しています。
  p.title(v-else) 商品情報がみつかりません
  p.desc
    | オカダヤお取り扱い商品のみに限り、情報を表示します。
    | 新商品など一部の取り扱い商品については、反映が遅れる場合があります。

  button.negative(v-if="fromFavorite" @click="$router.push('/favorite')") 一覧に戻る
  button.negative(@click="$router.push('/redirect')") 他の商品を読み取る
</template>

<script>
export default {
  props: {
    fromFavorite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //お気に入りに登録されていたが、商品DBから見つからなかった場合(つまり取り扱いが終了している)
      endOfSale: this.fromFavorite
    };
  }
};
</script>

<style lang="sass" scoped>
.container
  display: flex
  flex-direction: column
  padding: 12.6vh 12.8vw 0

.title
  font-weight: bold
  margin: 2.1vh 0 6.3vh

button
  align-self: center
  margin-top: 5%
</style>
